
import { useState } from "react"
import { Link } from "react-router-dom"

export default function NewsSection() {
	const [activeIndex, setActiveIndex] = useState(2)

	const handleIndex = (index) => {
		setActiveIndex(index)
	}
	return (
		<section className="news-section fix section-padding">
			<div className="container">
				<div className="row g-4">
					<div
						onClick={() => handleIndex(1)}
						className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
						data-wow-delay=".2s"
					>
						<div
							className={
								activeIndex === 1
									? "news-box-items mt-0 active"
									: "news-box-items mt-0"
							}
						>
							<div className="news-image">
								<img src="assets/img/news/Blog-1.png" alt="img" />
								<img src="assets/img/news/Blog-1.png" alt="img" />
							</div>
							<div className="news-content">
								<ul className="post-list">
									<li>5 May 2025</li>
									{/* <li>Construction</li> */}
								</ul>
								<h4>
									<Link to="/Why-WPC-Doors-Are-the-Future-of-Indian-Homes">
										Why WPC Doors Are the Future of Indian Homes ?
									</Link>
								</h4>
								<div className="author-items">
									<div className="author-info">
									<img src="assets/img/news/Vishal(CEO).png" alt="img" style={{ width: '50px', height: '50px' }} />
										<div className="content">
											<h6>CEO</h6>
											<p>Vishal Patel</p>
										</div>
									</div>
									<Link to="/Why-WPC-Doors-Are-the-Future-of-Indian-Homes" className="link-btn">
										Read More <i className="fa-solid fa-arrow-right" />
									</Link>
								</div>
							</div>
						</div>
					</div>
					<div
						onClick={() => handleIndex(2)}
						className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
						data-wow-delay=".4s"
					>
						<div
							className={
								activeIndex === 5
									? "news-box-items mt-0 active"
									: "news-box-items mt-0"
							}
						>
							<div className="news-image">
								<img src="assets/img/news/Blog-2.png" alt="img" />
								<img src="assets/img/news/Blog-2.png" alt="img" />
							</div>
							<div className="news-content">
								<ul className="post-list">
									{/* <li>Industry</li>	 */}
									<li>10 May 2025</li>
								</ul>
								<h4>
									<Link to="/WPC-vs-Wooden-Doors-What-Should-You-Choose">
										WPC vs. Wooden Doors – What Should You Choose?
									</Link>
								</h4>
								<div className="author-items">
									<div className="author-info">
									<img src="assets/img/news/Vishal(CEO).png" alt="img" style={{ width: '50px', height: '50px' }} />
										<div className="content">
											<h6>CEO</h6>
											<p>Vishal Patel</p>
										</div>
									</div>
									<Link to="/WPC-vs-Wooden-Doors-What-Should-You-Choose" className="link-btn">
										Read More <i className="fa-solid fa-arrow-right" />
									</Link>
								</div>
							</div>
						</div>
					</div>
					<div
						onClick={() => handleIndex(3)}
						className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
						data-wow-delay=".6s"
					>
						<div
							className={
								activeIndex === 6
									? "news-box-items mt-0 active"
									: "news-box-items mt-0"
							}
						>
							<div className="news-image">
								<img src="assets/img/news/Blog-3.jpg" alt="img" />
								<img src="assets/img/news/Blog-3.jpg" alt="img" />
							</div>
							<div className="news-content">
								<ul className="post-list">
									{/* <li>Industry</li> */}
									<li>15 May 2025</li>
								</ul>
								<h4>
									<Link to="/How-To-Choose-the-Right-WPC-Door-Frame">
										How to Choose the Right WPC Door Frame for Your Project ?
									</Link>
								</h4>
								<div className="author-items">
									<div className="author-info">
										<img src="assets/img/news/Vishal(CEO).png" alt="img" style={{ width: '50px', height: '50px' }} />
										<div className="content">
											<h6>CEO</h6>
											<p>Vishal Patel</p>
										</div>
									</div>
									<Link to="/How-To-Choose-the-Right-WPC-Door-Frame" className="link-btn">
										Read More <i className="fa-solid fa-arrow-right" />
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* <div
					className="page-nav-wrap pt-5 text-center wow fadeInUp"
					data-wow-delay=".3s"
				>
					<ul>
						<li>
							<Link className="page-numbers icon" to="/#">
								<i className="fa-solid fa-arrow-left" />
							</Link>
						</li>
						<li>
							<Link className="page-numbers" to="/#">
								01
							</Link>
						</li>
						<li>
							<Link className="page-numbers" to="/#">
								02
							</Link>
						</li>
						<li>
							<Link className="page-numbers" to="/#">
								03
							</Link>
						</li>
						<li>
							<Link className="page-numbers icon" to="/#">
								<i className="fa-solid fa-arrow-right" />
							</Link>
						</li>
					</ul>
				</div> */}
			</div>
		</section>
	)
}
